import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const SectionService = sdk.getService('SectionService');

export const useSyncedSectionsCourses = (sectionId?: string) => {
  const { isLoading, data, error } = useQuery({
    queryKey: ['syncedSectionsCourses', sectionId],
    queryFn: () => SectionService.getSyncedSectionsCourses(sectionId!),
    enabled: !!sectionId
  });

  return {
    syncedCourses: data ?? [],
    isLoading,
    error
  };
};
